import { BASE_URL_V2 } from 'constants/api';

import actions from './index';

export const ACTIONS = {
  GET: 'ACTIVITY_ITEMS_GET',
  GET_SUCCESS: 'ACTIVITY_ITEMS_GET_SUCCESS',
  GET_FAILURE: 'ACTIVITY_ITEMS_GET_FAILURE',
};

export const get = actions.get(
  learnosityRef =>
    `${BASE_URL_V2}/curriculum/learnosity-items/?learnosity_reference=${learnosityRef}`,
  {
    PENDING: ACTIONS.GET,
    SUCCESS: ACTIONS.GET_SUCCESS,
    FAILURE: ACTIONS.GET_FAILURE,
  },
);
